import { gql } from '@apollo/client';

export const CREATE_SEGMENT_MUTATION = gql`
    mutation createSegment($input: CreateSegmentInput!) {
        result: createSegment(input: $input) {
            id
            name
            userCount
            groupClassCompanies
            groupClassPrimaryRoles
            groupClassJobFunctions
            groupClassTechnicalSales
            groupClassWorkloads
        }
    }
`;